import { render, staticRenderFns } from "./reactionDetailsDialog.vue?vue&type=template&id=e3241eb4"
import script from "./reactionDetailsDialog.vue?vue&type=script&lang=js"
export * from "./reactionDetailsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports